<ion-router-outlet *ngIf="initialized"></ion-router-outlet>